export const en = {
  'receipt.documentTitle': 'Receipt {number}',
  'receipt.print': 'Print',
  'receipt.loading': 'Loading receipt…',
  'receipt.heading': 'RECEIPT',
  'receipt.invoiceNumber': 'Invoice no.',
  'receipt.date': 'Date',
  'receipt.member': 'Member',
  'receipt.memberNumber': 'Member no.',
  'receipt.validBetween': 'Valid {from} – {to}',
  'receipt.validFrom': 'Valid from {date}',
  'receipt.validUntil': 'Valid until {date}',
  'receipt.paidBy': 'Paid by',
  'receipt.onlineVia': 'Online via {provider}',
  'receipt.status': 'Status',
  'receipt.refundOn': 'Refund {date}',
  'receipt.refundedTotal': 'Refunded total',
  'receipt.total': 'TOTAL',
  'receipt.netTotal': 'NET TOTAL',
  'receipt.servedBy': 'Served by {name}',
  'receipt.note': 'Note: {note}',
  'receipt.thanks': 'Thank you for training with us',
  'receipt.keep': 'Keep this receipt for your records',
  'receipt.notFiscal': 'Not a fiscal receipt',
  'receipt.error.forbidden': 'Receipt not available',
  'receipt.error.forbiddenHint': 'You can only view receipts for your own payments.',
  'receipt.error.notFound': 'Receipt not found',
  'receipt.error.notFoundHint': 'This payment does not exist or belongs to another gym.',
  'receipt.error.missingHint': 'The link is missing a payment reference.',
  'receipt.error.failed': 'Could not load the receipt',
};

export const ka: Record<keyof typeof en, string> = {
  'receipt.documentTitle': 'ქვითარი {number}',
  'receipt.print': 'ბეჭდვა',
  'receipt.loading': 'ქვითარი იტვირთება…',
  'receipt.heading': 'ქვითარი',
  'receipt.invoiceNumber': 'ინვოისის №',
  'receipt.date': 'თარიღი',
  'receipt.member': 'წევრი',
  'receipt.memberNumber': 'წევრის №',
  'receipt.validBetween': 'მოქმედებს {from} – {to}',
  'receipt.validFrom': 'მოქმედებს {date}-დან',
  'receipt.validUntil': 'მოქმედებს {date}-მდე',
  'receipt.paidBy': 'გადახდის მეთოდი',
  'receipt.onlineVia': 'ონლაინ, {provider}',
  'receipt.status': 'სტატუსი',
  'receipt.refundOn': 'დაბრუნება {date}',
  'receipt.refundedTotal': 'სულ დაბრუნებული',
  'receipt.total': 'სულ',
  'receipt.netTotal': 'სულ, დაბრუნების გამოკლებით',
  'receipt.servedBy': 'მოგემსახურათ: {name}',
  'receipt.note': 'შენიშვნა: {note}',
  'receipt.thanks': 'გმადლობთ, რომ ჩვენთან ვარჯიშობთ',
  'receipt.keep': 'შეინახეთ ეს ქვითარი',
  'receipt.notFiscal': 'არ არის ფისკალური ქვითარი',
  'receipt.error.forbidden': 'ქვითარი მიუწვდომელია',
  'receipt.error.forbiddenHint': 'შეგიძლიათ ნახოთ მხოლოდ საკუთარი გადახდების ქვითრები.',
  'receipt.error.notFound': 'ქვითარი ვერ მოიძებნა',
  'receipt.error.notFoundHint': 'ეს გადახდა არ არსებობს ან სხვა დარბაზს ეკუთვნის.',
  'receipt.error.missingHint': 'ბმულს აკლია გადახდის მითითება.',
  'receipt.error.failed': 'ქვითარი ვერ ჩაიტვირთა',
};
